module.exports = __webpack_public_path__ + "static/img/FI.621ca26b.svg";